import { useEffect, useState } from 'react';
import { clx } from '../../lib/utils';
import { AppTitle } from '../AppTitle';

const listeners = new Set<(value: boolean) => void>();

export const isFullScreenLoadingIndicatorVisible = {
  current: false,
};

export const FullScreenLoadingIndicator = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    listeners.add(setIsVisible);
    return () => {
      listeners.delete(setIsVisible);
    };
  }, []);

  return (
    <div
      className={clx(
        `bg-background-secondary fixed inset-0 z-50 flex-col items-center justify-center gap-4`,
        isVisible ? 'flex' : 'hidden'
      )}
    >
      <AppTitle className="text-[17vw] md:text-2xl" />
      <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-t-2 border-gray-900" />
    </div>
  );
};

export const showFullScreenLoadingIndicator = () => {
  isFullScreenLoadingIndicatorVisible.current = true;
  listeners.forEach((listener) => listener(true));
};

export const hideFullScreenLoadingIndicator = () => {
  isFullScreenLoadingIndicatorVisible.current = false;
  listeners.forEach((listener) => listener(false));
};
